import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icon-bar-chart.svg'
import _imports_1 from '@/assets/icon-bar-chart-active.svg'
import _imports_2 from '@/assets/icon-line-chart.svg'
import _imports_3 from '@/assets/icon-line-chart-active.svg'
import _imports_4 from '@/assets/icon-line-chart-time.svg'
import _imports_5 from '@/assets/icon-line-chart-time-active.svg'
import _imports_6 from '@/assets/btn_close-w.svg'


const _hoisted_1 = {
  key: 0,
  class: "jr-inline-block jr-mr-5 jr-align-middle",
  src: _imports_0,
  alt: "bar-chart"
}
const _hoisted_2 = {
  key: 1,
  class: "jr-inline-block jr-mr-5 jr-align-middle",
  src: _imports_1,
  alt: "bar-chart"
}
const _hoisted_3 = {
  key: 2,
  class: "jr-text-sm jr-font-bold jr-inline-block jr-align-middle"
}
const _hoisted_4 = {
  key: 0,
  class: "jr-inline-block jr-mr-5 jr-align-middle",
  src: _imports_2,
  alt: "line-chart"
}
const _hoisted_5 = {
  key: 1,
  class: "jr-inline-block jr-mr-5 jr-align-middle",
  src: _imports_3,
  alt: "line-chart"
}
const _hoisted_6 = {
  key: 2,
  class: "jr-text-sm jr-font-bold jr-inline-block jr-align-middle"
}
const _hoisted_7 = {
  key: 0,
  class: "jr-inline-block jr-mr-5 jr-align-middle",
  src: _imports_4,
  alt: "area"
}
const _hoisted_8 = {
  key: 1,
  class: "jr-inline-block jr-mr-5 jr-align-middle",
  src: _imports_5,
  alt: "area"
}
const _hoisted_9 = {
  key: 2,
  class: "jr-text-sm jr-font-bold jr-inline-block jr-align-middle"
}
const _hoisted_10 = { class: "close" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", { src: _imports_6 }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_UISpeechBubble = _resolveComponent("UISpeechBubble")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["jr-absolute jr-z-10 jr-top-0 jr-left-0 jr-h-screen jr-bg-primary jr-shadow-lg", {'right_column': !_ctx.isCapturing, 'jr-opacity-0': _ctx.isCapturing}]),
      style: _normalizeStyle({ width: _ctx.minimum ? '64px' : '240px' })
    }, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", {
          class: "jr-w-full jr-cursor-pointer jr-relative",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeNav(_ctx.ReportNavigationType.PeopleVolume))),
          onMouseover: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleMouseHover(_ctx.ReportNavigationType.PeopleVolume))),
          onMouseleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleMouseLeave && _ctx.handleMouseLeave(...args)))
        }, [
          _createVNode(_component_router_link, { to: "/report" }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(["jr-p-6", {
                'bg-current jr-text-primary': _ctx.isPeopleVolumneSelected,
                'jr-text-white': !_ctx.isPeopleVolumneSelected
              }])
              }, [
                (!_ctx.isPeopleVolumneSelected)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_1))
                  : _createCommentVNode("", true),
                (_ctx.isPeopleVolumneSelected)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_2))
                  : _createCommentVNode("", true),
                (!_ctx.minimum)
                  ? (_openBlock(), _createElementBlock("h1", _hoisted_3, "人数ボリュームの変化"))
                  : _createCommentVNode("", true)
              ], 2)
            ]),
            _: 1
          })
        ], 32),
        _createElementVNode("li", {
          class: "jr-w-full jr-cursor-pointer jr-relative",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeNav(_ctx.ReportNavigationType.SamedayAction))),
          onMouseover: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleMouseHover(_ctx.ReportNavigationType.SamedayAction))),
          onMouseleave: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleMouseLeave && _ctx.handleMouseLeave(...args)))
        }, [
          _createVNode(_component_router_link, { to: "/report/same_day_series" }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(["jr-p-6", {
                'bg-current jr-text-primary': _ctx.isSamedayActionSelected,
                'jr-text-white': !_ctx.isSamedayActionSelected
              }])
              }, [
                (!_ctx.isSamedayActionSelected)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                  : _createCommentVNode("", true),
                (_ctx.isSamedayActionSelected)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                  : _createCommentVNode("", true),
                (!_ctx.minimum)
                  ? (_openBlock(), _createElementBlock("h1", _hoisted_6, "同日行動"))
                  : _createCommentVNode("", true)
              ], 2)
            ]),
            _: 1
          })
        ], 32),
        _createElementVNode("li", {
          class: "jr-w-full jr-cursor-pointer jr-relative",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeNav(_ctx.ReportNavigationType.OneHourGap))),
          onMouseover: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleMouseHover(_ctx.ReportNavigationType.OneHourGap))),
          onMouseleave: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleMouseLeave && _ctx.handleMouseLeave(...args)))
        }, [
          _createVNode(_component_router_link, { to: "/report/one_hour_series" }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(["jr-p-6", {
                'bg-current jr-text-primary': _ctx.isOneHourGapSelected,
                'jr-text-white': !_ctx.isOneHourGapSelected
              }])
              }, [
                (!_ctx.isOneHourGapSelected)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                  : _createCommentVNode("", true),
                (_ctx.isOneHourGapSelected)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                  : _createCommentVNode("", true),
                (!_ctx.minimum)
                  ? (_openBlock(), _createElementBlock("h1", _hoisted_9, "前後1時間行動"))
                  : _createCommentVNode("", true)
              ], 2)
            ]),
            _: 1
          })
        ], 32)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", {
          class: "btn_close",
          style: _normalizeStyle({ transform: (_ctx.minimum ? 'rotate(180deg)' : 'rotate(0deg)') })
        }, [
          _createElementVNode("a", {
            href: "#",
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onClickClose && _ctx.onClickClose(...args)))
          }, _hoisted_12)
        ], 4)
      ])
    ], 6),
    (_ctx.activeNav === _ctx.ReportNavigationType.PeopleVolume)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "chip_01",
          style: _normalizeStyle({ marginLeft: _ctx.minimum ? '94px' : '270px' })
        }, [
          _createVNode(_component_UISpeechBubble, {
            class: "jr--right-50 jr-top-0 jr-bottom-0 jr-h-25 jr-m-auto jr-w-50",
            label: "平日・土日祝日／曜日別や時間帯から市民／市外の比率を表示します"
          })
        ], 4))
      : _createCommentVNode("", true),
    (_ctx.activeNav === _ctx.ReportNavigationType.SamedayAction)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "chip_02",
          style: _normalizeStyle({ marginLeft: _ctx.minimum ? '94px' : '270px' })
        }, [
          _createVNode(_component_UISpeechBubble, {
            class: "jr--right-50 jr-top-0 jr-bottom-0 jr-h-25 jr-m-auto jr-w-50",
            label: "出発・到着・立ち寄りの同日行動を地点時間帯別にヒートマップで表示します"
          })
        ], 4))
      : _createCommentVNode("", true),
    (_ctx.activeNav === _ctx.ReportNavigationType.OneHourGap)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "chip_03",
          style: _normalizeStyle({ marginLeft: _ctx.minimum ? '94px' : '270px' })
        }, [
          _createVNode(_component_UISpeechBubble, {
            class: "jr--right-50 jr-top-0 jr-bottom-0 jr-h-18 jr-m-auto jr-w-50",
            label: "前後1時間の行動をヒートマップ表示します"
          })
        ], 4))
      : _createCommentVNode("", true)
  ], 64))
}